import React, { useEffect, useReducer } from 'react'
import { useAccount } from 'wagmi'
import { useTranslation } from 'react-i18next'

import Leaderboard from '../components/leaderboard/Leaderboard'
import { WALLET_ACCOUNT_STATUS } from '../util/walletConnect.helpers'
import {
  leaderboardReducer,
  leaderboardInitialState
} from '../store/reducers/leaderboard'
import Loading from '../components/shared/loading/Loading'
import { getLeaderboardAPI } from '../util/api.helpers'

const LeaderboardContainer = ({ mainProfile }) => {
  const { t } = useTranslation()

  const [leaderboardProfile, leaderboardDispatch] = useReducer(
    leaderboardReducer,
    leaderboardInitialState
  )

  useEffect(() => {
    getLeaderboardAPI(leaderboardDispatch)
  }, [])

  const { address, status } = useAccount()

  const isWalletConnected =
    status === WALLET_ACCOUNT_STATUS.CONNECTED && address

  return (
    <>
      {['connecting', 'reconnecting'].includes(status) ||
      leaderboardProfile.loading ? (
        <Loading />
      ) : (
        <Leaderboard
          t={t}
          leaderboardProfile={leaderboardProfile}
          address={isWalletConnected && address}
          mainProfile={mainProfile}
        />
      )}
    </>
  )
}

export default LeaderboardContainer
